export const getWikiLang = (market) => {
    switch (market) {
        case 'sk':
        case 'pl':
        case 'hu':
        case 'ro':
            return market;

        case 'cz':
            return 'cs';
    }

    return 'en';
};
